import CryptoJS from "crypto-js";

export const formatDate = (date) => {
  if (!date) return '';
  const newDate = new Date(date);
  return newDate.toLocaleDateString("en-US", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
};

export const encrypt = (text) => {
  const encrypted = CryptoJS.AES.encrypt(text, process.env.REACT_APP_ENCRPTION_SECRET_KEY).toString();
  return encrypted;
};
export const decryptValue = (encrypted) => {
  if (!process.env.REACT_APP_ENCRPTION_SECRET_KEY) throw new Error("Decryption key is missing");
  try {
    const bytes = CryptoJS.AES.decrypt(encrypted, process.env.REACT_APP_ENCRPTION_SECRET_KEY);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    return decrypted || "";
  } catch (e) {
    return "";
  }
};